(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["comparison-table"] && !Shopify.designMode) return;
  try {
    
  (function() {
    let isUpdating = false;
    let updateScheduled = false;
    
    function waitForImages(table, callback) {
      const images = table.querySelectorAll('img');
      if (images.length === 0) {
        callback();
        return;
      }
      
      let loadedCount = 0;
      const totalImages = images.length;
      
      function checkComplete() {
        loadedCount++;
        if (loadedCount === totalImages) {
          callback();
        }
      }
      
      images.forEach(img => {
        if (img.complete) {
          checkComplete();
        } else {
          img.addEventListener('load', checkComplete, { once: true });
          img.addEventListener('error', checkComplete, { once: true });
        }
      });
    }
    
    function updateColumnHeights() {
      if (window.innerWidth < 768 || isUpdating) {
        updateScheduled = false;
        return;
      }
      
      isUpdating = true;
      updateScheduled = false;
      
      const tables = document.querySelectorAll('.comparison-table--style-2 .comparison-table__table');
      if (tables.length === 0) {
        isUpdating = false;
        return;
      }
      
      let tablesProcessed = 0;
      const totalTables = tables.length;
      
      tables.forEach(table => {
        waitForImages(table, function() {
          // Use requestAnimationFrame to ensure layout is stable
          requestAnimationFrame(function() {
            // Small delay to ensure all layout calculations are complete
            setTimeout(function() {
              // Column 2
              const col2Header = table.querySelector('thead th:nth-child(2)');
              const col2Cells = table.querySelectorAll('tbody td:nth-child(2)');
              if (col2Header && col2Cells.length > 0) {
                // Use getBoundingClientRect for more accurate height
                const headerRect = col2Header.getBoundingClientRect();
                let col2Height = headerRect.height;
                col2Cells.forEach(cell => {
                  const cellRect = cell.getBoundingClientRect();
                  col2Height += cellRect.height;
                });
                col2Header.style.setProperty('--column-height', col2Height + 'px');
              }
              
              // Column 3
              const col3Header = table.querySelector('thead th:nth-child(3)');
              const col3Cells = table.querySelectorAll('tbody td:nth-child(3)');
              if (col3Header && col3Cells.length > 0) {
                const headerRect = col3Header.getBoundingClientRect();
                let col3Height = headerRect.height;
                col3Cells.forEach(cell => {
                  const cellRect = cell.getBoundingClientRect();
                  col3Height += cellRect.height;
                });
                col3Header.style.setProperty('--column-height', col3Height + 'px');
              }
              
              tablesProcessed++;
              if (tablesProcessed === totalTables) {
                isUpdating = false;
                if (updateScheduled) {
                  updateColumnHeights();
                }
              }
            }, 50);
          });
        });
      });
    }
    
    function scheduleUpdate() {
      if (isUpdating) {
        updateScheduled = true;
        return;
      }
      updateColumnHeights();
    }
    
    // Run on load
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(scheduleUpdate, 100);
      });
    } else {
      setTimeout(scheduleUpdate, 100);
    }
    
    // Run after all resources load
    window.addEventListener('load', function() {
      setTimeout(scheduleUpdate, 200);
    });
    
    // Run on resize with debouncing
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(scheduleUpdate, 300);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["customer-reviews"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const reviewList = document.querySelector('.customer-reviews__review-list');
    if (reviewList) {
      // Ensure scroll starts at the leftmost position
      reviewList.scrollLeft = 0;
      
      // Also set on load in case of any delays
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function() {
          reviewList.scrollLeft = 0;
        });
      } else {
        // DOM already loaded
        setTimeout(function() {
          reviewList.scrollLeft = 0;
        }, 0);
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
